module.exports = __webpack_public_path__ + "img/ring_r_c_null_1@2x.8fa2fc57.png";